import {useEffect} from "react";
import {EventType, EventListener} from "../../../apis";
import {useWebsocketContext} from "../../pages/session/WebsocketContext";

export function useSessionEventListener(eventType: EventType, callback: EventListener) {
    const { websocket } = useWebsocketContext();

    useEffect(() => {
        const onMessage: EventListener = async (data) => {
            await callback(data);
        };

        websocket.addEventListener(eventType, onMessage);

        return () => {
            websocket.removeEventListener(eventType, onMessage);
        };
    });
}
